import React from 'react';
import { Link } from 'react-router-dom';
import { PlayCircle, ShieldCheck, ArrowRight } from 'lucide-react';
import { VIDEO_TESTIMONIALS } from '../mock';
import { Reveal } from './Shared';
import { useLang } from '../context/LangContext';

export const VideoTestimonial = ({ item = VIDEO_TESTIMONIALS[0], idPrefix = 'video-testimonial' }) => {
  const { tr } = useLang();
  return (
  <Reveal>
    <div data-testid={idPrefix} className="grid md:grid-cols-[minmax(0,320px)_1fr] gap-8 lg:gap-12 items-center bg-white border border-teal-50 rounded-3xl p-5 md:p-8 shadow-sm">
      <div className="relative mx-auto w-full max-w-[320px] rounded-2xl overflow-hidden bg-teal-950 shadow-xl aspect-[480/848]">
        <video
          data-testid={`${idPrefix}-player`}
          poster={item.poster}
          controls
          playsInline
          preload="none"
          className="w-full h-full object-cover"
        >
          <source src={item.src} type="video/mp4" />
          <source src={item.webm} type="video/webm" />
        </video>
      </div>
      <div>
        <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-wider uppercase text-coral-500" style={{ color: '#ff7a63' }}>
          <PlayCircle size={16} /> {tr('Patient Story', 'मरीज़ की कहानी')}
        </span>
        <h3 data-testid={`${idPrefix}-title`} className="text-2xl md:text-3xl text-teal-900 mt-3 text-balance" style={{ fontWeight: 600 }}>{tr(item.title, item.hiTitle)}</h3>
        <p className="text-slate-600 leading-relaxed mt-4">{tr(item.summary, item.hiSummary)}</p>
        <ul className="mt-5 space-y-2 text-sm text-slate-600">
          {tr(item.points, item.hiPoints).map((p) => (
            <li key={p} className="flex gap-2"><ShieldCheck size={17} className="text-teal-600 shrink-0 mt-0.5" />{p}</li>
          ))}
        </ul>
        <p className="text-xs text-slate-400 mt-5">{tr(item.note, item.hiNote)}</p>
        <Link data-testid={`${idPrefix}-cta`} to="/second-opinion" className="btn-outline inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm mt-6">
          {tr('Get an expert opinion', 'विशेषज्ञ की राय लें')} <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  </Reveal>
  );
};
